import React, { useEffect, useState } from "react";
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Switch from "react-switch";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';

// Agrega esta importación
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';

const Inventory = () => {
    const [title, setTitle] = useState("Agregar Refacción");
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [usages, setUsages] = useState([]);
    const [typesUnits, setTypesUnits] = useState([]);
    const [units, setUnits] = useState([]);
    const [inventoryId, setInventoryId] = useState(0);
    const [sku, setSku] = useState('');
    const [description, setDescription] = useState('');
    const [price, setPrice] = useState(0);
    const [quantity, setQuantity] = useState(0);
    const [type, setType] = useState('Consumible');
    const [brand, setBrand] = useState('');
    const [typeUnitId, setTypeUnitId] = useState(0);
    const [unitId, setUnitId] = useState(0);
    const [km, setKm] = useState('');
    const [quantityUsed, setQuantityUsed] = useState(1);
    const [notes, setNotes] = useState('');
    const [active, setActive] = useState(0);
    const [inactive, setInactive] = useState(0);
    const [statusFilter, setStatusFilter] = useState(2);
    const [typeUnitFilter, setTypeUnitFilter] = useState(0);
    const [unitFilter, setUnitFilter] = useState(0);
    const [inventoryFilter, setInventoryFilter] = useState(0);
    const [search, setSearch] = useState('');
    const [addStockQuantity, setAddStockQuantity] = useState(0);



const [statusFilterItems, setStatusFilterItems] = useState(2);
const [typeUnitFilterItems, setTypeUnitFilterItems] = useState(0);
const [statusFilterUsages, setStatusFilterUsages] = useState(2);
const [unitFilterUsages, setUnitFilterUsages] = useState(0);
const [inventoryFilterUsages, setInventoryFilterUsages] = useState(0);


    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        getAllItems();
        getTypesUnits();
        getUnits();
        getAllUsages();

        setTimeout(() => {
            initializeSelect2();
        }, 500);
    

        $('#modal-add-item').on('shown.bs.modal', function () {
        // Reforzar la inicialización de Select2 cuando el modal se muestra
        setTimeout(() => {
            if ($('#type_unit_id').data('select2')) {
                $('#type_unit_id').select2('destroy');
            }
            $('#type_unit_id').select2({ 
                width: "100%", 
                dropdownParent: $('#modal-add-item') 
            });
        }, 100);
    });
    
        
        $('#modal-usage').on('shown.bs.modal', function () {
            reinitializeSelect2();
        });
        
        $('#modal-add-stock').on('shown.bs.modal', function () {
            // Focus en el input de cantidad
            setTimeout(() => {
                $('#addStockQuantity').focus();
            }, 100);
        });
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
    }, []);

    const refreshSelect2 = (selector) => {
        setTimeout(() => {
            $(selector).select2({ 
                width: "100%", 
                dropdownParent: $('#modal-usage') 
            }).on('change', function(e) {
                if (selector === '#unit_id') {
                    setUnitId(parseInt($(this).val()));
                }
            });
        }, 100);
    };


    const initializeSelect2 = () => {
        // Destruir cualquier instancia previa
        if ($('#type_unit_id').data('select2')) {
            $('#type_unit_id').select2('destroy');
        }
        if ($('#unit_id').data('select2')) {
            $('#unit_id').select2('destroy');
        }
        
        // Inicializar Select2 para modales
        $('#type_unit_id').select2({ 
            width: "100%", 
            dropdownParent: $('#modal-add-item') 
        }).on('change', function(e) {
            setTypeUnitId(parseInt($(this).val()));
        });
        
        $('#unit_id').select2({ 
            width: "100%", 
            dropdownParent: $('#modal-usage') 
        }).on('change', function(e) {
            setUnitId(parseInt($(this).val()));
        });
        
        // Inicializar filtros
        $('#status_filter').select2({ width: "100%" });
        $('#type_unit_filter').select2({ width: "100%" });
        $('#unit_filter').select2({ width: "100%" });
        $('#inventory_filter').select2({ width: "100%" });
    };

  

    const getTypesUnits = async () => {
        try {
            // Usar la ruta correcta que existe en tu api.php
            const response = await axios.get(ENDPOINT + 'get-all-types-units/2'); // 2 = todos (activos e inactivos)
            const typesArray = response.data.data.map(function (element) {
                return {
                    label: element.name,
                    value: element.type_unit_id,
                };
            });
            setTypesUnits(typesArray);
        } catch (error) {
            console.log("Error al cargar tipos de unidades:", error);
        }
    };

    console.log("Llamando a:", ENDPOINT + 'get-all-units');

    const getUnits = async () => {
        try {
            const form = new FormData();
            // Los parámetros que espera el endpoint según tu controlador
            form.append("status_filter", 2); // 2 = todos (activos e inactivos)
            form.append("type_filter", 0);   // 0 = todos los tipos
            
            console.log("Llamando a endpoint con:", { 
                status_filter: 2, 
                type_filter: 0 
            });
            
            const response = await axios.post(ENDPOINT + 'get-all-units', form);
            
            console.log("Respuesta completa:", response);
            console.log("Datos recibidos:", response.data);
            
            if (response.data.res && response.data.data) {
                const unitsArray = response.data.data.map(function (element) {
                    return {
                        label: element.name || element.unit_name || `Unidad ${element.unit_id}`,
                        value: element.unit_id,
                        originalData: element // Para debug
                    };
                });
                
                console.log("Unidades mapeadas:", unitsArray);
                setUnits(unitsArray);
                
                // Inicializar Select2 después de cargar los datos
                setTimeout(() => {
                    if ($('#unit_id').length) {
                        $('#unit_id').select2({ 
                            width: "100%", 
                            dropdownParent: $('#modal-usage') 
                        }).on('change', function(e) {
                            setUnitId(parseInt($(this).val()));
                        });
                        
                        // Forzar actualización visual
                        $('#unit_id').trigger('change.select2');
                    }
                }, 300);
                
            } else {
                console.error("Error en la respuesta del servidor:", response.data.msg);
                // Mostrar unidades vacías para evitar errores
                setUnits([]);
            }
        } catch (error) {
            console.error("Error al cargar unidades:", error);
            if (error.response) {
                console.error("Respuesta del error:", error.response.data);
                console.error("Status:", error.response.status);
            }
            setUnits([]);
        }
    };

const getAllItems = async () => {
    setLoading(true);
    if ($.fn.DataTable.isDataTable('.main-items')) {
        $('.main-items').DataTable().destroy();
    }
    const form = new FormData();
    form.append("status_filter", statusFilterItems); // Usar estado separado
    form.append("type_unit_filter", typeUnitFilterItems); // Usar estado separado
    form.append("search", search);
    await axios.post(ENDPOINT + 'get-all-inventory-items', form)
        .then((response) => {
            setItems(response.data.data);
            setActive(response.data.data.filter((e) => e.status === 1).length);
            setInactive(response.data.data.filter((e) => e.status === 0).length);
            setTimeout(() => {
                $('.main-items').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 50,
                    responsive: false,
                    autoWidth: false,
                    paging: true,
                    ordering: false,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No hay registros",
                        "searchPlaceholder": "Buscar",
                    },
                });
                setLoading(false);
            }, 100);
        })
        .catch(function (error) {
            setLoading(false);
            console.log(error);
        });
};

const getAllUsages = async () => {
    setLoading(true);
    var table = $('.main-usages').DataTable();
    table.destroy();
    const form = new FormData();
    form.append("status_filter", statusFilterUsages); // Usar estado separado
    form.append("unit_filter", unitFilterUsages); // Usar estado separado
    form.append("inventory_filter", inventoryFilterUsages); // Usar estado separado
    await axios.post(ENDPOINT + 'get-all-inventory-usages', form).then((response) => {
            setUsages(response.data.data);
            setTimeout(() => {
                $('.main-usages').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 50,
                    responsive: false,
                    autoWidth: false,
                    paging: true,
                    ordering: false,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No hay registros",
                        "searchPlaceholder": "Buscar",
                    },
                });
                setLoading(false);
            }, 100);
        }).catch(function (error) {
            setLoading(false);
            console.log(error);
        });
    };

    const handleNewItem = () => {
        clearItemForm();
    };

    const handleSubmitItem = async (e) => {
        e.preventDefault();
        setLoading(true);
        const form = new FormData();
        form.append("sku", sku);
        form.append("description", description);
        form.append("price", price);
        form.append("quantity", quantity);
        form.append("type", type);
        form.append("brand", brand);
        form.append("type_unit_id", typeUnitId);

        if (inventoryId === 0) {
            await axios.post(ENDPOINT + 'store-inventory-item', form)
                .then((response) => {
                    getAllItems();
                    clearItemForm();
                    setLoading(false);
                    $("#closemodal-item").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch((error) => {
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        } else {
            await axios.put(ENDPOINT + 'update-inventory-item/' + inventoryId, {
                sku, description, price, quantity, type, brand, type_unit_id: typeUnitId
            })
                .then((response) => {
                    getAllItems();
                    clearItemForm();
                    setLoading(false);
                    $("#closemodal-item").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch((error) => {
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        }
    };

    const clearItemForm = () => {
        setInventoryId(0);
        setSku('');
        setDescription('');
        setPrice(0);
        setQuantity(0);
        setType('Consumible');
        setBrand('');
        setTypeUnitId(0);
        setTitle("Agregar Refacción");
        
        // Limpiar Select2 después de cerrar el modal
        setTimeout(() => {
            if ($('#type_unit_id').data('select2')) {
                $('#type_unit_id').val(0).trigger('change');
            }
        }, 300);
    };

    const handleEditItem = async (id) => {
        setLoading(true);
        await axios.get(ENDPOINT + 'get-detail-inventory-item/' + id)
            .then((response) => {
                setLoading(false);
                const data = response.data.data;
                setInventoryId(data.inventory_id);
                setSku(data.sku);
                setDescription(data.description);
                setPrice(data.price);
                setQuantity(data.quantity);
                setType(data.type);
                setBrand(data.brand);
                setTypeUnitId(data.type_unit_id);
                setTitle("Editar Refacción");
            
                // Esperar al siguiente ciclo de renderizado
                setTimeout(() => {
                    // Destruir Select2 existente
                    if ($('#type_unit_id').data('select2')) {
                        $('#type_unit_id').select2('destroy');
                    }
                    
                    // Inicializar Select2
                    $('#type_unit_id').select2({ 
                        width: "100%", 
                        dropdownParent: $('#modal-add-item') 
                    });
                    
                    // Establecer el valor
                    $('#type_unit_id').val(data.type_unit_id).trigger('change');
                    
                    // Mostrar el modal usando jQuery (más compatible con tus otros modales)
                    $('#modal-add-item').modal('show');
                }, 100);
            })
            .catch((error) => {
                setLoading(false);
                console.log(error);
            });
    };

    const handleDeleteItem = (id, name) => {
        Swal.fire({
            title: `¿Desea eliminar la refacción [ ${name} ] ?`,
            text: "No podrá recuperarlo",
            icon: "warning",
            confirmButtonText: "Sí, eliminarlo",
            confirmButtonColor: "#469408",
            showCancelButton: true,
            cancelButtonColor: "#c71c22",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios.delete(ENDPOINT + 'delete-inventory-item/' + id)
                    .then((response) => {
                        getAllItems();
                        setLoading(false);
                        Swal.fire({
                            icon: "success",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    })
                    .catch((error) => {
                        setLoading(false);
                        Swal.fire({
                            icon: "error",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: true,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    });
            }
        });
    };

    const handleNewUsage = () => {
        clearUsageForm();
    };


    const reinitializeSelect2 = () => {
        setTimeout(() => {
            // Destruir Select2 existente antes de reinicializar
            if ($('#type_unit_id').data('select2')) {
                $('#type_unit_id').select2('destroy');
            }
            if ($('#unit_id').data('select2')) {
                $('#unit_id').select2('destroy');
            }
            
            // Inicializar Select2 para modales
            $('#type_unit_id').select2({ 
                width: "100%", 
                dropdownParent: $('#modal-add-item') 
            });
            
            $('#unit_id').select2({ 
                width: "100%", 
                dropdownParent: $('#modal-usage') 
            });
        }, 300);
    };
        

    const handleAddStock = async (e) => {
        e.preventDefault();
        setLoading(true);
    setAddStockQuantity(0);
        
        await axios.put(ENDPOINT + 'add-inventory-stock/' + inventoryId, {
            quantity: parseInt(addStockQuantity)
        })
        .then((response) => {
            getAllItems();
            setLoading(false);
            $("#modal-add-stock").modal("hide");
            Swal.fire({
                icon: "success",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 3000,
                html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        })
        .catch((error) => {
            setLoading(false);
            Swal.fire({
                icon: "error",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        });
    };
    

    const handleSubmitUsage = async (e) => {
        e.preventDefault();
        setLoading(true);
        const user = JSON.parse(localStorage.getItem('dataUser'));
        const user_id = user.user_id;
        const form = new FormData();
        form.append("inventory_id", inventoryId);
        form.append("unit_id", unitId);
        form.append("km", km);
        form.append("quantity_used", quantityUsed);
        form.append("notes", notes);
        form.append("user_id", user_id);

        await axios.post(ENDPOINT + 'register-inventory-usage', form)
            .then((response) => {
                getAllUsages();
                getAllItems();
                clearUsageForm();
                setLoading(false);
                $("#closemodal-usage").trigger("click");
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch((error) => {
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const clearUsageForm = () => {
        setInventoryId(0);
        setUnitId(0);
        setKm('');
        setQuantityUsed(1);
        setNotes('');
        
        setTimeout(() => {
            $('#unit_id').val(0).trigger('change');
            refreshSelect2('#unit_id');
        }, 100);
    };

    const handlePrintItems = async () => {
        setLoading(true);
        const form = new FormData();
        form.append("status_filter", statusFilter);
        form.append("type_unit_filter", typeUnitFilter);
        form.append("search", search);
        await axios.post(ENDPOINT + 'print-pdf-inventory', form, { responseType: "blob" })
            .then((response) => {
                const url = window.URL.createObjectURL(response.data);
                window.open(url, '_blank');
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.log(error);
            });
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <>
            {loading && <Loader />}
            {/* Modal para agregar/editar refacciones */}
            <div className="modal fade" id="modal-add-item" aria-labelledby="modal-add-item" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-header-modal">
                            <h4 className="modal-title">
                                {inventoryId === 0 ? <i className="fas fa-plus-circle me-2"></i> : <i className="fas fa-edit me-2"></i>}
                                {title}
                            </h4>
                            <button onClick={clearItemForm} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={handleSubmitItem}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="sku" className="col-form-label col-form-label-sm">
                                                SKU <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese SKU"
                                                id="sku"
                                                name="sku"
                                                value={sku}
                                                onChange={(e) => setSku(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="description" className="col-form-label col-form-label-sm">
                                                Descripción <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese descripción"
                                                id="description"
                                                name="description"
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="price" className="col-form-label col-form-label-sm">
                                                Precio <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese precio"
                                                id="price"
                                                name="price"
                                                value={price}
                                                onChange={(e) => setPrice(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="quantity" className="col-form-label col-form-label-sm">
                                                Cantidad <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese cantidad"
                                                id="quantity"
                                                name="quantity"
                                                value={quantity}
                                                onChange={(e) => setQuantity(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="type" className="col-form-label col-form-label-sm">
                                                Tipo <span className="bills-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="type"
                                                name="type"
                                                value={type}
                                                onChange={(e) => setType(e.target.value)}
                                                required
                                            >
                                                <option value="Consumible">Consumible</option>
                                                <option value="Desgaste">Desgaste</option>
                                                <option value="Remplazo">Remplazo</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="brand" className="col-form-label col-form-label-sm">
                                                Marca
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese marca"
                                                id="brand"
                                                name="brand"
                                                value={brand}
                                                onChange={(e) => setBrand(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="type_unit_id" className="col-form-label col-form-label-sm">
                                                Tipo de Unidad <span className="bills-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="type_unit_id"
                                                name="type_unit_id"
                                                required
                                            >
                                                <option selected value="0">Seleccione</option>
                                                {typesUnits.map((item, index) => (
                                                    <option
                                                        key={index}
                                                        value={item.value}
                                                        selected={item.value === typeUnitId}
                                                    >
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer bills-form-actions">
                                <button
                                    type="submit"
                                    className="btn btn-success">
                                    <i className="fa-regular fa-floppy-disk me-1"></i>
                                    {inventoryId === 0 ? "Guardar" : "Actualizar"}
                                </button>
                                <button
                                    onClick={clearItemForm}
                                    id="closemodal-item"
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal">
                                    <i className="fa-solid fa-ban me-1"></i> Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>


           
<div className="modal fade" id="modal-add-stock" aria-labelledby="modal-add-stock" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
    <div className="modal-dialog modal-sm modal-dialog-centered">
        <div className="modal-content">
            <div className="modal-header bg-header-modal">
                <h4 className="modal-title">
                    <i className="fas fa-plus-circle me-2"></i> Agregar Existencias
                </h4>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <form onSubmit={handleAddStock}>
                <div className="modal-body">
                    <div className="form-group">
                        <label htmlFor="addStockQuantity" className="col-form-label col-form-label-sm">
                            Cantidad a agregar <span className="bills-required">*</span>
                        </label>
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Cantidad"
                            id="addStockQuantity"
                            name="addStockQuantity"
                            value={addStockQuantity}
                            onChange={(e) => setAddStockQuantity(e.target.value)}
                            min="1"
                            required
                        />
                    </div>
                </div>
                <div className="modal-footer bills-form-actions">
                    <button type="submit" className="btn btn-success">
                        <i className="fa-regular fa-floppy-disk me-1"></i> Agregar
                    </button>
                    <button type="button" className="btn btn-danger" data-bs-dismiss="modal">
                        <i className="fa-solid fa-ban me-1"></i> Cancelar
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>                                 



            {/* Modal para registro de uso */}
            <div className="modal fade" id="modal-usage" aria-labelledby="modal-usage" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-header-modal">
                            <h4 className="modal-title">
                                <i className="fas fa-truck me-2"></i> Registrar Uso de Refacción
                            </h4>
                            <button onClick={clearUsageForm} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={handleSubmitUsage}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="inventory_id" className="col-form-label col-form-label-sm">
                                                Refacción <span className="bills-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="inventory_id"
                                                name="inventory_id"
                                                value={inventoryId}
                                                onChange={(e) => setInventoryId(e.target.value)}
                                                required
                                            >
                                                <option selected value="0">Seleccione</option>
                                                {items.map((item, index) => (
                                                    <option key={index} value={item.inventory_id}>
                                                        {item.sku} - {item.description}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="unit_id" className="col-form-label col-form-label-sm">
                                                Unidad <span className="bills-required">*</span>
                                            </label>
                                           
                                            <select
                                            className="form-control form-control-sm"
                                              id="unit_id"
                                             name="unit_id"
                                             value={unitId}
                                             onChange={(e) => setUnitId(parseInt(e.target.value))}
                                             required
                                                >
                                              <option value="0">Seleccione</option>
                                                {units.map((item, index) => (
                                             <option key={index} value={item.value}>
                                              {item.label}
                                               </option>
                                                             ))}
                                                    </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="km" className="col-form-label col-form-label-sm">
                                                Km <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese kilometraje"
                                                id="km"
                                                name="km"
                                                value={km}
                                                onChange={(e) => setKm(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="quantity_used" className="col-form-label col-form-label-sm">
                                                Cantidad Usada <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                className={`form-control form-control-sm`}
                                                placeholder="Cantidad usada"
                                                id="quantity_used"
                                                name="quantity_used"
                                                value={quantityUsed}
                                                onChange={(e) => setQuantityUsed(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="notes" className="col-form-label col-form-label-sm">
                                                Notas
                                            </label>
                                            <textarea
                                                className={`form-control form-control-sm`}
                                                rows="2"
                                                id="notes"
                                                name="notes"
                                                value={notes}
                                                onChange={(e) => setNotes(e.target.value)}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer bills-form-actions">
                                <button
                                    type="submit"
                                    className="btn btn-success">
                                    <i className="fa-regular fa-floppy-disk me-1"></i> Registrar Uso
                                </button>
                                <button
                                    onClick={clearUsageForm}
                                    id="closemodal-usage"
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal">
                                    <i className="fa-solid fa-ban me-1"></i> Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <ContentHeader title="Módulo de Inventario de Refacciones" />
            </div>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-8">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-box me-1"></i> Inventario de Refacciones
                                </h4>
                            </div>
                            <div className="col-md-4" style={{ textAlign: "right" }}>
                                <button
                                    onClick={handleNewItem}
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-add-item"
                                    className="btn btn-success btn-sm me-1">
                                    <i className="fas fa-plus-circle me-1"></i> Agregar Refacción
                                </button>

                                

                                <button
                                    onClick={handleNewUsage}
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-usage"
                                    className="btn btn-warning btn-sm me-1">
                                    <i className="fas fa-minus-circle me-1"></i> Registrar Uso
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="bills-indications row mb-4">
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="status_filter" className="col-form-label col-form-label-sm">
                                        Estado
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="status_filter"
                                        name="status_filter"
                                        value={statusFilter}
                                        onChange={(e) => setStatusFilter(e.target.value)}
                                    >
                                        <option value="2">Todos</option>
                                        <option value="1">Activo</option>
                                        <option value="0">Inactivo</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="type_unit_filter" className="col-form-label col-form-label-sm">
                                        Tipo de Unidad
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="type_unit_filter"
                                        name="type_unit_filter"
                                        value={typeUnitFilter}
                                        onChange={(e) => setTypeUnitFilter(e.target.value)}
                                    >
                                        <option value="0">Todos</option>
                                        {typesUnits.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="search" className="col-form-label col-form-label-sm">
                                        Buscar
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        id="search"
                                        name="search"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6 mb-2 text-end">
                                <button
                                    onClick={() => getAllItems()}
                                    className="btn btn-primary btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-search me-1"></i> Buscar
                                </button>
                                <button
                                    onClick={handlePrintItems}
                                    className="btn btn-danger btn-sm me-1">
                                    <i className="fa-solid fa-file-pdf me-1"></i> Descargar
                                </button>
                            </div>
                            <div className="d-flex justify-content-center items-align-center">
                                <div className="col-md-6 col-sm-6 col-xs-12 mt-3">
                                    <div className="form-group">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr className="text-center">
                                                    <td className="indications-table" width="30%">Total</td>
                                                    <td className="indications-table" width="30%">Activos</td>
                                                    <td className="indications-table" width="30%">Inactivos</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td id="TuserT">{active + inactive}</td>
                                                    <td id="TuserA">{active}</td>
                                                    <td id="TuserI">{inactive}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <table className="table table-hover main-items table-striped">
                            <thead>
                                <tr>
                                    <th className="text-center">#</th>
                                    <th className="text-center">SKU</th>
                                    <th className="text-center">Descripción</th>
                                    <th className="text-center">Precio</th>
                                    <th className="text-center">Cantidad</th>
                                    <th className="text-center">Tipo</th>
                                    <th className="text-center">Marca</th>
                                    <th className="text-center">Tipo de Unidad</th>
                                    
                                    <th className="text-center">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.inventory_id}</td>
                                        <td>{item.sku}</td>
                                        <td>{item.description}</td>
                                        <td>{item.price}</td>
                                        <td>{item.quantity}</td>
                                        <td>{item.type}</td>
                                        <td>{item.brand}</td>
                                        <td>
                {/* Prueba estas diferentes formas de acceder al tipo de unidad */}
                {item.type_unit?.name || 
                 item.typeUnit?.name || 
                 item.type_unit_name || 
                 item.type_unit_id?.name ||
                 'No especificado'}
            </td>
           
<td className="text-center">
    <button
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Editar"
        className="btn-sm btn btn-warning me-1"
        onClick={() => handleEditItem(item.inventory_id)}>
        <i className="fa-solid fa-pen-to-square"></i>
    </button>
    <button
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Eliminar"
        className="btn-sm btn btn-danger me-1"
        onClick={() => handleDeleteItem(item.inventory_id, item.description)}>
        <i className="fa-solid fa-trash-can"></i>
    </button>
    <button
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Agregar Existencias"
        className="btn-sm btn btn-info me-1"
        onClick={() => {
            setInventoryId(item.inventory_id);
            setAddStockQuantity(0);
            
            var modal = new bootstrap.Modal(document.getElementById('modal-add-stock'));
            modal.show();
        }}>
        <i className="fa-solid fa-boxes-stacked"></i>
    </button>
</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Sección de Uso de Refacciones */}
                <div className="card mt-4">
                    <div className="card-header">
                        <h4 className="card-title m-0 page-title">
                            <i className="bi bi-truck me-1"></i> Historial de Uso de Refacciones
                        </h4>
                    </div>
                    <div className="card-body">
                        <div className="bills-indications row mb-4">
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="status_filter" className="col-form-label col-form-label-sm">
                                        Estado
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="status_filter"
                                        name="status_filter"
                                        value={statusFilter}
                                        onChange={(e) => setStatusFilter(e.target.value)}
                                    >
                                        <option value="2">Todos</option>
                                        <option value="1">Activo</option>
                                        <option value="0">Inactivo</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="unit_filter" className="col-form-label col-form-label-sm">
                                        Unidad
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="unit_filter"
                                        name="unit_filter"
                                        value={unitFilter}
                                        onChange={(e) => setUnitFilter(e.target.value)}
                                    >
                                        <option value="0">Todos</option>
                                        {units.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="inventory_filter" className="col-form-label col-form-label-sm">
                                        Refacción
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="inventory_filter"
                                        name="inventory_filter"
                                        value={inventoryFilter}
                                        onChange={(e) => setInventoryFilter(e.target.value)}
                                    >
                                        <option value="0">Todos</option>
                                        {items.map((item, index) => (
                                            <option key={index} value={item.inventory_id}>
                                                {item.sku} - {item.description}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-6 mb-2 text-end">
                                <button
                                    onClick={() => getAllUsages()}
                                    className="btn btn-primary btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-search me-1"></i> Buscar
                                </button>
                            </div>
                        </div>
                        <table className="table table-hover main-usages table-striped">
                            <thead>
                                <tr>
                                    <th className="text-center">#</th>
                                    <th className="text-center">Refacción</th>
                                    <th className="text-center">Unidad</th>
                                    <th className="text-center">Km</th>
                                    <th className="text-center">Cantidad Usada</th>
                                    <th className="text-center">Notas</th>
                                    <th className="text-center">Fecha y Hora Ingreso</th>
                                    <th className="text-center">Usuario</th>
                                </tr>
                            </thead>
                            <tbody>
                                {usages.map((usage, index) => (
                                    <tr key={index}>
                                        <td>{usage.usage_id}</td>
                                        <td>{usage.inventory?.sku} - {usage.inventory?.description}</td>
                                        <td>{usage.unit?.name}</td>
                                        <td>{usage.km}</td>
                                        <td>{usage.quantity_used}</td>
                                        <td>{usage.notes}</td>
                                        <td>{usage.date_created}</td>
                                        <td>{usage.user?.name} {usage.user?.last_name}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Inventory;